import templateUrl from 'emun.cart/payfabric/cart-creditcard-payfabric-prompt.htm';
import ServiceBus from 'servicestack/service-bus'
import basicController from 'servicestack/basic.controller.properties'
//import config from 'servicestack/tags/_config'
//import labels from 'servicestack/tags/_labels'
import modals from 'webmodals/modals'
import resolve from "ioc/resolve";

class CartCreditCardPayFabricPromptController {
    constructor(options, $uibModalInstance) {
        const $ctrl = this;
        basicController($ctrl);
        $ctrl.retailerId = options.retailerId;
		$ctrl.title = options.title || ' Credit Card...';

        $ctrl.modal = $uibModalInstance;
        $ctrl.$dismiss = $ctrl.dismiss = $uibModalInstance.dismiss;
        $ctrl.$close = $ctrl.close = $uibModalInstance.close;

        let $rootScope = resolve("$rootScope");
		$rootScope.$on('creditCardCreated', (e,args) => {
            $ctrl.$close();
		});
    }

}

const CartCreditCardPayFabricPrompt = {
    open(options) {
        return modals.open(Object.assign({
            templateUrl,
            resolve: {
                options: () => options
            },
            bindToController: true,
            controller: CartCreditCardPayFabricPromptController,
            controllerAs: '$ctrl'
        }, (options || {}).modal)).result;
    }
};

export default CartCreditCardPayFabricPrompt;